<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h3>Thank You</h3>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Description</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in cart">
          <td>{{item.description}}</td>
          <td>${{item.amount}}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${{totalPrice}}</td>
        </tr>
      </tbody>
    </table>

    <dl class="row" v-if="paymentusConfirmationNumber">
      <dt class="col-sm-3">Paymentus Confirmation Number:</dt>
      <dd class="col-sm-9">{{paymentusConfirmationNumber}}</dd>
    </dl>

    <p>
      Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
      system. After approval of your permit application by the department, it will be emailed to the address you
      provided with your application.
    </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-3">Phone:</dt>
      <dd class="col-sm-9">312-603-8200 (and follow appropriate prompt)</dd>
    </dl>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput';
import { getOpenBurnCart, confirmChaseOpenBurnTransaction, getTransactionCart, validatePermitNumber } from '@/js/FormFunctions';

import { CapitalizeFilter } from '@/js/Mixins';

export default {
  name: 'OpenBurnApplicationThankYou',
  components: { BaseInput },
  mixins: [CapitalizeFilter],
  data() {
    return {
      applicationNumber: null,
      fetchingData: false,
      chaseConfirmationNumber: null,
      chaseTransactionMode: null,
      returnSessionId: null,
      cart: null,
    };
  },
  mounted() {
    this.fetchingData = true;
    this.transactionId = this.$route.params.transactionId;
    if (Object.hasOwnProperty.call(this.$route.query, 'confirmationNumber')) {
      this.paymentusConfirmationNumber = this.$route.query.confirmationNumber;
    }
    if (Object.hasOwnProperty.call(this.$route.query, 'applicationNumber')) {
      this.applicationNumber = this.$route.query.applicationNumber;
    }
    const self = this;
    if (this.paymentusConfirmationNumber != null) {
      getOpenBurnCart(this.applicationNumber)
        .then((result) => {
          self.cart = result;
          self.fetchingData = false;
        })
        .catch((error) => {
          self.fetchingData = false;
        });
    } else {
      getTransactionCart(this.transactionId)
        .then((result) => {
          self.cart = result;
          self.fetchingData = false;
        })
        .catch((error) => {
          self.fetchingData = false;
        });
    }
  },
  computed: {
    totalPrice() {
      if (this.cart == null || this.cart.length === 0) {
        return 0;
      }
      let amount = 0;
      for (let i = 0; i < this.cart.length; i++) {
        amount += Number(this.cart[i].amount);
      }
      return parseFloat(amount).toFixed(2);
    },
  },
};
</script>
